import { create } from "zustand";
import { useAwaitTransition } from "../ui/hooks/use-router-refresh";

interface AdminStore {
	isLoading: boolean;
	startLoading: () => void;
	stopLoading: () => void;
	startGlobalTransition: (callback: () => Promise<void>) => void;
}

export const useAdminStore = create<AdminStore>((set) => ({
	isLoading: false,
	startLoading: () => set({ isLoading: true }),
	stopLoading: () => set({ isLoading: false }),
	startGlobalTransition: async (callback) => {
		set({ isLoading: true });
		try {
			await callback();
		} finally {
			set({ isLoading: false });
		}
	},
}));

export const useStopGlobalTransition = () => {
	const stopLoading = useAdminStore((store) => store.stopLoading);
	return stopLoading;
};

export const useStartGlobalTransition = () => {
	const startGlobalTransition = useAdminStore((store) => store.startGlobalTransition);
	const awaitTransition = useAwaitTransition();
	return (callback: () => Promise<void>) =>
		startGlobalTransition(async () => {
			await callback();
			await awaitTransition();
		});
};
